module.exports = __webpack_public_path__ + "img/chez-bruno.6d43b099.jpg";